module.exports = __webpack_public_path__ + "img/electricity_icon.c2b3c27f.png";